export const SET_IS_GENDER_TYPE_PAGE='SET_IS_GENDER_TYPE_PAGE';
export const SET_IS_SELF_REGISTER='SET_IS_SELF_REGISTER'
export const SET_SELF_REGISTARTION_TYPE='SET_SELF_REGISTARTION_TYPE'
export const SET_IS_SELF_REGISTER_LANDING_PAGE='SET_IS_SELF_REGISTER_LANDING_PAGE'
export const SET_USER_TYPE_DATA='SET_USER_TYPE_DATA'


export interface setIsSelfRegister{
    type: typeof SET_IS_SELF_REGISTER;
    payload:any;
} 

export interface setSelfRegistartionType{
    type: typeof SET_SELF_REGISTARTION_TYPE;
    payload:any;
} 

export interface setIsSelfRegisterLandingPage{
    type: typeof SET_IS_SELF_REGISTER_LANDING_PAGE;
    payload:any;
} 
export interface setIsGenderTypePage{
    type: typeof SET_IS_GENDER_TYPE_PAGE;
    payload:any;
}

export interface setUserTypeData {
    type:typeof SET_USER_TYPE_DATA;
    payload: any;
};

export type registerationActionType =  setSelfRegistartionType | setIsSelfRegisterLandingPage |setUserTypeData |setIsGenderTypePage | setIsSelfRegister; 
